import React, { useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import {
  Dialog,
  Slide,
  Drawer,
  Button,
  Box,
  IconButton,
  Backdrop,
} from "@mui/material";
import { useSelector } from "react-redux";
import * as h from "../../../helpers/index";
import { API_FREE_CAN_PLAY } from "../../../constants/api";
import { setAnalyticsPlayGame } from "../../../helpers/analyticsHelpers";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import { BlackTooltip } from "./constants/playGameConfigs";
import { useScreenHelpers } from "../../../hooks/useScreenHelpers";
import { useActivities } from "../../../context/ActivitiesContext";
import { Import } from "lucide-react";
import GameFrame from "./GameFrame";
import { useContext } from "react";
import SystemContext from "../../../context/SystemContext";
import { useInvalidateUserCache } from "@hooks/useUserInfos";
import {
  useUpdateUserPlaysFree,
  useUserAccountInfos,
} from "hooks/useUserInfos";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const APlayGame = ({ refreshMedals }) => {
  const { isFullscreen, isTouchDevice } = useScreenHelpers();
  const [hover, setHover] = useState(false);
  const _navigate = useNavigate();
  const [curUrl, setCurUrl] = useState(null);
  const [open, setOpen] = useState(null);
  const [content, setContent] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const {
    // activeUser,
    session,
  } = useSelector((state) => state.session);

  const { data: activeUser } = useUserAccountInfos();

  const is_parent_paid = session ? session.is_parent_paid : false;
  const [mapRewardMedal, setMapRewardMedal] = useState({});
  const isFree = h.checkIsShowingModalLimit(session);
  const hasSavedPlayRef = useRef(false);
  const hasSyncedUserCacheRef = useRef(false);
  const { changePropertyUrl } = useContext(SystemContext);
  const invalidateUserCache = useInvalidateUserCache();

  const [
    freeCanPlay,
    isLoadingFreeCanPlay,
    errorFreeCanPlay,
    fetchFreeCanPlay,
  ] = useFetch({
    autoInit: false,
  });

  const {
    openGame,
    setOpenGame,
    setMedalReward,
    setOpenGameIsQuiz,
    openGameIsQuiz,
    setOpenModalQuiz,
    setOpenModalFree,
  } = useActivities();

  const openGameIsQuizRef = useRef(openGameIsQuiz);
  const { mutate: updateUserPlaysFree } = useUpdateUserPlaysFree();

  useEffect(() => {
    if (openGame && !curUrl) {
      console.log("🎮 openGame", openGame);
      console.log("session", session);
      if (!session) {
        _navigate("/login", { replace: true });
        return;
      }
      if (openGame.behavior_tags?.includes("experimente")) {
        setCurUrl(h.getActivityUrl(openGame, activeUser, is_parent_paid));
      }

      if (openGame.can_play) {
        setCurUrl(h.getActivityUrl(openGame, activeUser, is_parent_paid));
      }
    }
  }, [openGame, activeUser, is_parent_paid]);

  useEffect(() => {
    if (freeCanPlay != null) {
      // Se ainda existem jogadas gratuitas de jogos normais e existe um jogo aberto
      if (freeCanPlay?.plays_free >= 0 && openGame) {
        // Define a URL do jogo para abrir no iframe
        setCurUrl(h.getActivityUrl(openGame, activeUser, is_parent_paid));
      } else {
        //! (QUIZ) AGORA VERIFICA SE FOI ABERTO DENTRO DO QUIZ O JOGO E SE TEM JOGADAS
        // Caso não tenha jogadas normais, verifica se é um quiz e se ainda existem jogadas de quiz
        if (openGameIsQuiz && freeCanPlay?.quiz_plays_free >= 0 && openGame) {
          // Define a URL do quiz para abrir
          setCurUrl(h.getActivityUrl(openGame, activeUser, is_parent_paid));
        } else {
          // Se não houver mais jogadas disponíveis limpa o jogo aberto
          setOpenGame(null);

          //fecha o modal do jogo se estiver aberto
          if (open) closeGame();
        }
      }
    }
    // Executa sempre que o retorno da API freeCanPlay mudar
  }, [freeCanPlay, openGameIsQuiz, openGame]);

  useEffect(() => {
    if (curUrl) {
      setOpen(true);
      setAnalyticsPlayGame({
        name: openGame.name,
        id: openGame.id,
      });
      changePropertyUrl(`/jogar/${openGame.path}`, {}, true);
    }
  }, [curUrl]);

  //! BUG
 const handleMessage = useCallback(
  (event) => {
    if (!curUrl?.includes(event.origin) || !event.data.message) return;
    let rewardData = null;
    try {
      rewardData = JSON.parse(atob(event.data.message));
    } catch (error) {
      console.warn(
        "Mensagem não estava em Base64, tentando JSON direto:",
        error,
      );
      try {
        rewardData = JSON.parse(event.data.message);
      } catch {
        console.error("Mensagem inválida recebida:", event.data.message);
        return;
      }
    }

    const layoutName = rewardData?.data?.layoutName;

    // 1. Se o jogo saiu da GameplayScreen ,
    // liberamos a trava para permitir a PRÓXIMA partida.
    if (layoutName && layoutName !== "GameplayScreen") {
      hasSavedPlayRef.current = false;
    }

    // 2. Processa o início da jogada na GameplayScreen
    if (isFree && layoutName === "GameplayScreen") {
      // Se já registrou ESTA partida atual, ignora as mensagens subsequentes da mesma partida
      if (hasSavedPlayRef.current) return;
      hasSavedPlayRef.current = true; // Trava para a partida atual

      if (
        openGameIsQuizRef.current &&
        activeUser.freeCanPlay?.quiz_plays_free <= 0
      ) {
        closeGame({ openGameIsQuiz: true });
        setOpenModalQuiz(true);
        return;
      }

      if (
        activeUser.freeCanPlay?.plays_free <= 0 &&
        !openGameIsQuizRef.current
      ) {
        closeGame();
        setOpenModalFree(true);
        return;
      }

      setTimeout(() => {
        if (open && !isLoadingFreeCanPlay) {
          updateUserPlaysFree(openGameIsQuizRef.current ? "?quiz=true" : "");
        }
      }, 10000);
    }

    if (
      Array.isArray(rewardData) &&
      mapRewardMedal[rewardData.medal_id] === undefined
    ) {
      setMedalReward(rewardData);
      setMapRewardMedal((prevMap) => ({
        ...prevMap,
        [rewardData.medal_id]: rewardData,
      }));
      invalidateUserCache();
      hasSyncedUserCacheRef.current = true;
    }

    if (rewardData?.message === "Score successfully registered.") {
      const userId = activeUser?.sub || session?.sub;
      if (userId) {
        invalidateUserCache({ includeGoal: true });
        hasSyncedUserCacheRef.current = true;
        h.UpdateLocalAmountPlay(userId);
      }
    }
  },
  [curUrl, open, isFree, isLoadingFreeCanPlay],
);

  useEffect(() => {
    if (!open) return;

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [open, handleMessage]);

  const closeGame = (configObj = { openGameIsQuiz: false }) => {
    hasSavedPlayRef.current = false;

    if (!hasSyncedUserCacheRef.current) {
      refreshMedals();
    }

    hasSyncedUserCacheRef.current = false;
    setOpenGame(null);

    // recebe info se era quiz (default: false)
    setOpenGameIsQuiz(configObj.openGameIsQuiz);
    setContent(null);
    setCurUrl(null);
    setOpen(false);
    setHover(false);
    unlock();
    changePropertyUrl("back");
  };

  function lock(orientation) {
    let de = document.getElementById("openGameFrame");
    if (isTouchDevice) {
      try {
        if (de.requestFullscreen) de.requestFullscreen();
        else if (de.mozRequestFullScreen) de.mozRequestFullScreen();
        else if (de.webkitRequestFullscreen) de.webkitRequestFullscreen();
        else if (de.msRequestFullscreen) de.msRequestFullscreen();
        console.log("Fullscreen ativado");
        window.screen.orientation.lock(orientation);
      } catch (error) {
        console.log("Erro ao tentar fullscreen:", error);
      }
    }
  }

  function unlock() {
    if (isTouchDevice) {
      try {
        window.screen.orientation.unlock();
      } catch (error) {
        console.error("Erro ao desbloquear orientação:", error);
      }

      // tenta sair do fullscreen só se estiver em fullscreen
      const de = document;
      try {
        if (
          de.fullscreenElement ||
          de.webkitFullscreenElement ||
          de.mozFullScreenElement ||
          de.msFullscreenElement
        ) {
          if (de.exitFullscreen) de.exitFullscreen();
          else if (de.webkitExitFullscreen) de.webkitExitFullscreen();
          else if (de.mozCancelFullScreen) de.mozCancelFullScreen();
          else if (de.msExitFullscreen) de.msExitFullscreen();
        }
      } catch (error) {
        console.error("Erro ao sair do fullscreen:", error);
      }
    }
  }

  const clearCacheAndReloadGame = () => {
    const openGameFrame = document.getElementById("openGameFrame");

    if (openGameFrame && openGame) {
      const currentUrl = new URL(openGameFrame.src);
      const curCacheVersion = Date.now();
      const openGameCache = JSON.parse(
        localStorage.getItem("openGameCache") ?? "{}",
      );

      openGameCache[openGame.id] = curCacheVersion;
      localStorage.setItem("openGameCache", JSON.stringify(openGameCache));
      currentUrl.searchParams.set(
        "version",
        (openGame.version ?? 0) + "-" + curCacheVersion,
      );

      fetch(currentUrl, { cache: "no-store" })
        .then(() => {
          openGameFrame.src = currentUrl.href;
        })
        .catch((error) => console.error("Erro ao recarregar jogo:", error));
    }
  };

  useEffect(() => {
    if (curUrl) {
      setContent(<GameFrame curUrl={curUrl} openGame={openGame} lock={lock} />);
    }
  }, [curUrl]);
  const MENU_WIDTH = { xs: 22, md: 32 };

  useEffect(() => {
    if (open) {
      setModalContent(
        <>
          <Dialog
            fullScreen
            open={open}
            onClose={closeGame}
            slots={{
              transition: Transition,
            }}
            sx={{
              "& .MuiDialog-paper": {
                margin: 0,
                padding: 0,
                width: "100%",
                height: "100%",
                overflow: "hidden",
              },
            }}
          >
            <Backdrop
              open={hover && !isFullscreen}
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.2)",
                zIndex: 10,
                pointerEvents: "none",
              }}
            />
            <Box
              onMouseEnter={() => !isTouchDevice && setHover(true)}
              onMouseLeave={() => !isTouchDevice && setHover(false)}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                width: { xs: MENU_WIDTH.xs, md: MENU_WIDTH.md },
                height: "100%",
                zIndex: 2000,
                backgroundColor: "rgba(0, 0, 0, 1)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                  gap: 3,
                  p: 0.5,
                }}
              >
                <BlackTooltip
                  title="Fechar jogo"
                  enterDelay={500}
                  arrow
                  open={hover}
                  placement="left"
                >
                  <Button
                    onClick={closeGame}
                    sx={{
                      backgroundColor: "primary.main",
                      width: { xs: 15, md: 25 },
                      minWidth: { xs: 15, md: 25 },
                      height: { xs: 15, md: 25 },
                      padding: 0,
                    }}
                  >
                    <CloseIcon
                      sx={{
                        color: "primary.contrastText",
                        fontSize: { xs: 14, md: 18 },
                      }}
                    />
                  </Button>
                </BlackTooltip>

                <BlackTooltip
                  title="Recarregar"
                  enterDelay={500}
                  arrow
                  open={hover}
                  placement="left"
                >
                  <IconButton
                    onClick={clearCacheAndReloadGame}
                    color="primary"
                    sx={{
                      width: { xs: 15, md: 25 },
                      height: { xs: 15, md: 25 },
                      padding: 0,
                    }}
                  >
                    <ReplayIcon
                      sx={{
                        color: "primary.contrastText",
                        fontSize: { xs: 14, md: 18 },
                      }}
                    />
                  </IconButton>
                </BlackTooltip>
              </Box>
            </Box>

            {content && (
              <Box
                id="GameFrameContent"
                sx={{
                  backgroundColor: "black",
                  height: "100%",
                  pointerEvents: "all",
                  width: {
                    xs: `calc(100% - ${MENU_WIDTH.xs}px)`,
                    md: `calc(100% - ${MENU_WIDTH.md}px)`,
                  },
                }}
              >
                {content}
              </Box>
            )}
          </Dialog>
        </>,
      );
    } else {
      setModalContent(null);
    }
  }, [open, content, hover, isFullscreen]);

  return modalContent;
};

export default APlayGame;
